import { omit } from 'lodash/fp';
import update from 'immutability-helper';
import { EDITOR } from 'constants/actionTypes';

export const initialState = {
  visible: false,
  fetching: false,
  success: true,
  elementId: null,
  threads: {},
  activeThreads: new Set(),
};

const reduceCommentary = (state = initialState, action) => {
  /********** Helpers **********/

  const assign = changes => ({ ...state, ...changes });

  const updateThread = (id, changes) =>
    update(state.threads, { [id]: changes });

  /********** Reducers **********/

  switch (action.type) {
    case EDITOR.COMMENTARY.SHOW:
      return assign({ visible: true });

    case EDITOR.COMMENTARY.HIDE:
      return initialState;

    case EDITOR.COMMENTARY.REQUEST:
      return assign({ fetching: true, elementId: action.id });

    case EDITOR.COMMENTARY.REQUEST_SUCCESS: {
      const { commentThreads: threads, ...rest } = action.payload;
      return assign({ fetching: false, success: true, threads, ...rest });
    }

    case EDITOR.COMMENTARY.REQUEST_FAILURE:
      return assign({ success: false, fetching: false, threads: {} });

    case EDITOR.COMMENTARY.RESOLVE_THREAD:
      return assign({ threads: omit(action.id)(state.threads) });

    case EDITOR.COMMENTARY.POST_REPLY: {
      return assign({
        threads: updateThread(action.threadId, {
          comments: { $push: [action.comment] },
        }),
      });
    }

    case EDITOR.COMMENTARY.CREATE_THREAD: {
      const { thread } = action;
      return assign({
        threads: {
          ...state.threads,
          [thread.id]: thread,
        },
      });
    }

    case EDITOR.COMMENTARY.SET_ACTIVE_THREAD: {
      const { activeThreads } = state;
      activeThreads.add(action.id);
      return assign({ activeThreads });
    }

    case EDITOR.COMMENTARY.SET_UNACTIVE_THREAD: {
      const { activeThreads } = state;
      activeThreads.delete(action.id);
      return assign({ activeThreads });
    }

    default:
      return initialState;
  }
};

export default reduceCommentary;
